import { CommodityDto } from '@billing/app/api'
import { CommodityStore } from '@billing/stores/CommodityStore'
import { BaseDrawerStore } from '@billing/stores/base/BaseDrawerStore'
import { action, makeObservable, observable } from 'mobx'

export class CommodityDialogUIStore extends BaseDrawerStore<CommodityDto> {
  isDeleteOpen = false
  isDeactivateOpen = false
  isActivateOpen = false
  editingCommodity?: CommodityDto | undefined
  isCreateCatalogOpen = false

  constructor(private commodityStore: CommodityStore) {
    super(commodityStore)
    makeObservable(this, {
      isDeleteOpen: observable,
      isDeactivateOpen: observable,
      isActivateOpen: observable,
      editingCommodity: observable,
      isCreateCatalogOpen: observable,
      toggleCreateCatalogDialog: action,

      toggleActivate: action,
      toggleDelete: action,
      toggleDeactivate: action,
    })
  }

  public toggleActivate(commodity?: CommodityDto): void {
    this.editingCommodity = commodity
    this.isActivateOpen = !this.isActivateOpen
  }

  public toggleDeactivate(commodity?: CommodityDto): void {
    this.editingCommodity = commodity
    this.isDeactivateOpen = !this.isDeactivateOpen
  }

  public toggleCreateCatalogDialog(): void {
    this.isCreateCatalogOpen = !this.isCreateCatalogOpen
  }

  public toggleDelete(commodity?: CommodityDto): void {
    this.editingCommodity = commodity
    this.isDeleteOpen = !this.isDeleteOpen
  }
}
